// extracted by mini-css-extract-plugin
export default {"container2":"MyPet_container2__71Rwb","containerBox2":"MyPet_containerBox2__m7V8x","line":"MyPet_line__UiCIe"};